export class ModalObservacaoColetaController {
  constructor($scope, $uibModalInstance, Pedido, pedidoId, observacao) {
    $scope.pedidoId = pedidoId;
    $scope.observacao = observacao || '';

    $scope.confirmar = async () => {
      try {
        await Pedido.atualizarObservacao($scope.pedidoId, $scope.observacao);
        $uibModalInstance.close({ observacao: $scope.observacao });
      } catch (err) {
        $uibModalInstance.dismiss(err);
      }
    };

    $scope.cancelar = () => {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
